import { Button, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from 'react-collapse';

import { getTranslation, keys } from '../../../Resources/Translations';
import { RenderHTML } from '../../ReactComponents/RenderHTML';
import { CategoryHeaderProps } from './CategoryHeaderProps.csharp';

export const CategoryHeader = ({ title, ingress, expandableContent }: CategoryHeaderProps) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const expandableClassNames = classNames('CategoryPage__ExpandableContent', !ingress && 'CategoryPage__ExpandableContent--WithoutIngress');

    return (
        <div className="CategoryPage__Header">
            {title && <h1 className="CategoryPage__Title">{title}</h1>}

            {(ingress || expandableContent) && (
                <div className="CategoryPage__DescriptionContainer">
                    <div className="CategoryPage__DescriptionWrapper">
                        {ingress && <RenderHTML html={ingress} className="CategoryPage__Ingress" />}

                        {expandableContent && (
                            <>
                                {!isExpanded && (
                                    <div className="CategoryPage__ExpandButtonWrapper">
                                        <Button
                                            variant={ButtonVariant.Link}
                                            size={ButtonSize.Small}
                                            className="CategoryPage__ExpandButton"
                                            onClick={() => setIsExpanded(true)}
                                        >
                                            {getTranslation(keys['categoryPage.readMore'])}
                                        </Button>
                                    </div>
                                )}
                                <Collapse isOpened={isExpanded}>
                                    {expandableContent && <RenderHTML html={expandableContent} className={expandableClassNames} />}
                                </Collapse>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
